/**
 * Reusable Tooltip component
 *
 * NOTE(Carter): Multiline tool tips are harder to configure.
 * They should also only be 'left' or 'right' or the positioning
 * of the tooltip gets wonky
 * You should make sure to format and style the text component
 * yourself, and may need to include the breaking properties:
 *    word-wrap: 'break-word';
 *    white-space: 'normal';
 *
 * As well as telling it to be contained in the tooltip with
 *    width: 100%;
 *    height: 100%;
 *
 * See the example in Tooltip.stories.jsx
 */
import React, { useState } from 'react';
import { colors } from '../styleConstants';
import { TooltipTip, TooltipWrapper } from './Tooltip.styled';
function Tooltip(_a) {
    var content = _a.content, _b = _a.width, width = _b === void 0 ? 'fit-content' : _b, _c = _a.height, height = _c === void 0 ? 'fit-content' : _c, _d = _a.direction, direction = _d === void 0 ? 'top' : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? colors.primaryGreyLight : _e, _f = _a.textColor, textColor = _f === void 0 ? colors.trueBlack : _f, _g = _a.hoverTimeMs, hoverTimeMs = _g === void 0 ? 400 : _g, children = _a.children;
    // Parse values into user-friendly strings
    var timeoutFn;
    var _h = useState(false), active = _h[0], setActive = _h[1];
    var showTip = function () {
        timeoutFn = setTimeout(function () {
            setActive(true);
        }, hoverTimeMs);
    };
    var hideTip = function () {
        clearInterval(timeoutFn);
        setActive(false);
    };
    return (React.createElement(TooltipWrapper
    // When to show the tooltip
    , { 
        // When to show the tooltip
        onMouseEnter: showTip, onMouseLeave: hideTip },
        children,
        active && (React.createElement(TooltipTip, { width: width, height: height, direction: direction, backgroundColor: backgroundColor, textColor: textColor }, content))));
}
export default Tooltip;
